<ng-template #menuItemTemplate let-item="item" let-last="last">
    @if (item) {
        @if (!item.hidden) {
            @if (!item.feature || (item.feature | hasFeature)) {
                @if (item.subMenu?.length && !item.backButton) {
                    <li class="dropdown-header" *hasPrivilege="item.privilege">
                        <ng-container
                            *ngTemplateOutlet="
                                menuItem;
                                context: { item: item }
                            "
                        ></ng-container>
                    </li>
                }
                @if (
                    item.linkedMenu$ ||
                    item.linkedMenu?.length ||
                    item.backButton
                ) {
                    <li>
                        <button
                            class="dropdown-item {{
                                item.style ? 'text-' + item.style : ''
                            }}"
                            [attr.data-cy]="item.cySelector"
                            [class.active]="
                                item
                                    | fn
                                        : isSelected
                                        : selectedMenuItemValues
                                        : selectedMenuItemValue
                                        : isMulti
                            "
                            [disabled]="item.disabled"
                            (click)="manageLinkedMenu(item)"
                        >
                            <ng-container
                                *ngTemplateOutlet="
                                    menuItem;
                                    context: { item: item }
                                "
                            ></ng-container>
                        </button>
                    </li>
                } @else {
                    <li>
                        @if (item.routerLink) {
                            <button
                                ngbDropdownItem
                                class="dropdown-item {{
                                    item.style ? 'text-' + item.style : ''
                                }} link"
                                routerLinkActive="active"
                                [attr.data-cy]="item.cySelector"
                                [class.border-bottom-0]="last"
                                [class.active]="
                                    item
                                        | fn
                                            : isSelected
                                            : selectedMenuItemValues
                                            : selectedMenuItemValue
                                            : isMulti
                                "
                                [routerLink]="item.routerLink"
                                [queryParams]="item.queryParams"
                                [disabled]="item.disabled"
                                (click)="onClick(item)"
                            >
                                <ng-container
                                    *ngTemplateOutlet="
                                        menuItem;
                                        context: { item: item }
                                    "
                                ></ng-container>
                            </button>
                        } @else {
                            <button
                                ngbDropdownItem
                                class="dropdown-item {{
                                    item.style ? 'text-' + item.style : ''
                                }}"
                                [attr.data-cy]="
                                    item.cySelector || item.id || item.value
                                "
                                [class.border-bottom-0]="last"
                                [clmiUiDynamicFormSetup]="item.formSetup"
                                [modalId]="item.modalId"
                                [disabled]="item.disabled"
                                (click)="onClick(item)"
                                *hasPrivilege="item.privilege"
                            >
                                <ng-container
                                    *ngTemplateOutlet="
                                        menuItem;
                                        context: { item: item }
                                    "
                                ></ng-container>
                            </button>
                        }
                    </li>
                }
                @if (item.subMenu?.length) {
                    <ul class="dropdown-menu dropdown-flush ps-2">
                        @for (
                            subItem of item.subMenu;
                            track $index;
                            let last = $last
                        ) {
                            <ng-container
                                [ngTemplateOutlet]="menuItemTemplate"
                                [ngTemplateOutletContext]="{
                                    item: subItem,
                                    last: last,
                                }"
                            ></ng-container>
                        }
                    </ul>
                }
            }
        }
    }
</ng-template>

<ng-template #menuItem let-item="item">
    <div class="d-flex">
        @if (item.avatar) {
            <atom-avatar
                class="dropdown-item__avatar flex-shrink-0 me-2"
                size="md"
                [avatar]="item.avatar"
            ></atom-avatar>
        }
        @if ((item.icon || ghostIcons) && !hideIcons && !item.icon?.stack) {
            <wdx-icon
                class="dropdown-item__icon flex-shrink-0 me-2"
                [class.invisible]="!item.icon && ghostIcons"
                [ngClass]="item.iconSeverity | severity: ['text']"
                [icon]="item.icon"
                [scale]="1"
                [fixedWidth]="true"
            ></wdx-icon>
        }

        @if (item.icon?.stack) {
            <wdx-icon-stack class="me-0 stack-icon">
                @for (icon of item.icon.stack; track icon.stack) {
                    <wdx-icon
                        class="dropdown-item__icon flex-shrink-0"
                        [rotate]="icon.rotate"
                        [offsetTop]="icon.offsetTop"
                        [offsetLeft]="icon.offsetLeft"
                        [scale]="icon.scale"
                        [icon]="icon.icon + ' fa-stack-1x '"
                        [fixedWidth]="true"
                    ></wdx-icon>
                }
            </wdx-icon-stack>
        }

        @if (item.externalUrl) {
            <a class="flex-grow-1" target="_blank" [href]="item.externalUrl">
                {{ item.label }}
            </a>
        } @else {
            <div class="flex-grow-1">
                <div
                    class="text-wrap"
                    [attr.data-cy]="
                        'item-' + item.label | translateTokenisedString
                    "
                >
                    {{
                        item.translationKey
                            ? (item.translationKey | translateTokenisedString)
                            : (item.label | translateTokenisedString)
                    }}
                </div>
                @if (item.subLabels) {
                    <div class="small">
                        @for (
                            subLabel of item.subLabels;
                            track $index;
                            let last = $last
                        ) {
                            <span> {{ subLabel }} </span>
                            @if (!last) {
                                <span class="inline-bullet"></span>
                            }
                        }
                    </div>
                }
            </div>
        }
        <div class="flex-shrink-0 d-flex align-items-center">
            @if (item.severityIndicators?.length) {
                <atom-severity-indicators
                    [indicators]="item.severityIndicators"
                ></atom-severity-indicators>
            }
            @if (
                highlightSelected &&
                showCheckOnHighlight &&
                !item.linkedMenu &&
                !item.linkedMenu$
            ) {
                <wdx-icon
                    class="ms-2"
                    size="sm"
                    icon="check"
                    [class.invisible]="
                        !(
                            item
                            | fn
                                : isSelected
                                : selectedMenuItemValues
                                : selectedMenuItemValue
                                : isMulti
                        )
                    "
                ></wdx-icon>
            }
            @if (item.linkedMenu || item.linkedMenu$) {
                <wdx-icon
                    class="ms-2"
                    size="sm"
                    icon="chevron-right"
                ></wdx-icon>
            }
        </div>
    </div>
</ng-template>

@for (activeMenu of activeMenus; track $index; let i = $index) {
    <div data-cy="context-menu" [class.d-none]="i !== activeMenus.length - 1">
        @for (menuItem of activeMenu; track $index; let last = $last) {
            <ng-container
                [ngTemplateOutlet]="menuItemTemplate"
                [ngTemplateOutletContext]="{ item: menuItem, last: last }"
            ></ng-container>
        }
    </div>
}
